import { API } from '../api';
import { IFilterOptionValue, IFetchFiltersOptionsByCompanyRequestParams, IFilterOption, ISiteMarket } from './interface';

export const fetchSiteOptions = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOption[]> => {
    const path = `/filters/options/sites?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of sites!`);
};

export const fetchMeterEnrollmentEnrollmentIdOptions = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOption[]> => {
    const path = `/filters/options/meter-enrollment/enrollment-ids?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of Enrollment IDs!`);
};

export const fetchEventAccountManagers = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOptionValue[]> => {
    const path = `/filters/options/events/account-managers?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of account managers!`);
};

export const fetchAccountManagers = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOptionValue[]> => {
    const path = `/filters/options/accounts/account-managers?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of account managers!`);
};

export const fetchSiteMarkets = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<ISiteMarket[]> => {
    const path = `/filters/options/site/markets?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of markets!`);
};

export const fetchVendorBillItemPrograms = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOption[]> => {
    const path = `/filters/options/vendor-bill-item/programs?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of programs!`);
};

export const fetchVendorBillItemUtilities = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOption[]> => {
    const path = `/filters/options/vendor-bill-item/utilities?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of utilities!`);
};

export const fetchVendorBillTransactionIds = async (
    { company_id }: IFetchFiltersOptionsByCompanyRequestParams,
    signal?: AbortSignal | null
): Promise<IFilterOption[]> => {
    const path = `/filters/options/vendor-bill/transaction-ids?${new URLSearchParams({
        ...(company_id && { company_id: company_id.toString() }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of utilities!`);
};

export const fetchPjmLocationZipCodes = async (signal?: AbortSignal | null): Promise<IFilterOption[]> => {
    const path = `/filters/options/pjm/location/zip-codes`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of utilities!`);
};

export const fetchPjmRegistrationSeasons = async (signal?: AbortSignal | null): Promise<IFilterOption[]> => {
    const path = `/filters/options/pjm/registration/seasons`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of pjm registration seasons!`);
};
